/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import { IoFlash } from "react-icons/io5"
import QueryBuilderV2 from "../../modules/queryBuilder/QueryBuilderV2"
import { BackButton } from "../components/BreadCrumb"
import { FaBackward, FaCross } from "react-icons/fa"
import { BiArrowBack } from "react-icons/bi"
import { MdClose } from "react-icons/md"
import { useState } from "react"
import classNames from "classnames"
import { Button, Form, Input, Radio, Tag, Select } from 'antd';
import CodeExample from "../components/CodeExample"
import { useNewApiStep2 } from "../../modules/api/NewApiHook"
import { useRecoilState } from "recoil"
import { SQueryResults } from "../../modules/queryBuilder/QueryState"
import { useQueryIdV3 } from "../../modules/queryBuilder/QueryPadStateV3"
import { INTERVAL_SELECTIONS } from "../../modules/api/const"


const UseButton = ({
  onClick
}: any) => {
  return <button className="items-center bg-[#2b3cf5] flex text-[#fff] py-2 px-8" onClick={onClick}>
    <IoFlash />
    USE
  </button>
}

const FormItem = Form.Item;
const { TextArea } = Input;
const options: any = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}
const GraphQlForm = () => {

  // get data from useNewApiStep2
  const [
    { rpcStatusQueryLoading, rpcStatusCreating, values, queryDetail },
    { createNewApi, setValues },
  ] = useNewApiStep2(true);
  const queryId = useQueryIdV3();

  const [queryResults] = useRecoilState(SQueryResults(queryId));

  const columns = queryResults?.results?.metadata?.columns || [];

  const columnsOptions = columns.map((item: any) => {
    return {
      label: item.name,
      value: item.name,
    }
  })

  const [form] = Form.useForm();


  return <div className="py-4 px-4 flex flex-col justify-between h-[calc(100vh-96px)]">
    <Form
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
      form={form}
      layout="vertical"
      onFinish={async () => {
        await createNewApi()
      }}
      onValuesChange={(e) => {
        if (e.displayName) {
          setValues({ ...values, displayName: e.displayName })
        }
      }}
    >
      <div>
        <FormItem label="Title" name="displayName"
          rules={[{ required: true, message: 'Please input your username!' }]}

        >
          <Input placeholder="Title" />
        </FormItem>
        <FormItem label="Description(optional)" name="description">
          <TextArea rows={4} placeholder="Optional" />
        </FormItem>
        <FormItem label="Data Refresh" name="dataIngestIntervalSeconds">
          <Select
            style={{ width: '100%' }}
            placeholder="Please select"
            defaultValue={0}
            onChange={() => { }}
            options={INTERVAL_SELECTIONS}
          />
        </FormItem>
        <FormItem label="Column to Indexing" name={"resultIndexes"}>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Please select"
            defaultValue={[]}
            onChange={() => { }}
            options={columnsOptions}
          />
        </FormItem>
        <FormItem label="Enable Incremental Data Refresh">
          <Select
            style={{ width: '100%' }}
            placeholder="Please select"
            defaultValue={false}
            onChange={() => { }}
            options={[
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },

            ]}
          />
        </FormItem>
      </div>



      <div className="">
        <FormItem>
          <button type="submit" className="w-full btn bg-[#263dff] ">
            DEPLOY GRAPHQL
          </button>
        </FormItem>
      </div>
    </Form>
  </div>
}

const SqlSection = () => {
  const [format, setFormat] = useState('json')
  const renderContents = () => {
    switch (format) {
      case 'json':
        return <>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Installation" />
          </div>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Code Example - JSON" />
          </div>
        </>
      case 'csv':
        return <>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Installation" />
          </div>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Code Example - CSV" />
          </div>
        </>
      default:
        return <>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Installation" />
          </div>
          <div className="mb-6">
            <CodeExample code="asdasdasdas" title="Code Example" />
          </div>
        </>
    }
  }

  const commonClassNamses = "flex-1 tab"
  const activeClassNames = "font-semibold tab-active border-[#263dff] text-[#263dff] bg-[#f6f7f9]"

  return <div className="p-3">
    {/* tabs */}
    <div role="tablist" className="tabs border rounded flex overflow-hidden mb-6 mt-3">
      <a role="tab" className={
        classNames(commonClassNamses, {
          [activeClassNames]: format === 'json'
        })
      }
        onClick={() => {
          setFormat('json')
        }}>JSON</a>
      <a role="tab"
        className={
          classNames(commonClassNamses, {
            [activeClassNames]: format === 'csv'
          })
        }
        onClick={() => {
          setFormat('csv')
        }}>CSV</a>
    </div>
    {/* contents */}
    {
      renderContents()
    }

  </div>
}

export const UseSection = ({
  onClose
}: any) => {
  const [currentUseTab, setCurrentUseTab] = useState('graphql')

  const renderContents = () => {
    switch (currentUseTab) {
      case 'graphql':
        return <GraphQlForm />
      case 'sql':
        return <SqlSection />
      default:
        return <GraphQlForm />
    }
  }

  return <div className="fixed right-0 bg-[#fff] h-screen top-0 w-[360px] border-l-2 z-40">
    <div className="border-b-2 flex justify-between items-center px-3 py-2 font-semibold">
      <div>
        USE
      </div>
      <div>
        <MdClose onClick={onClose} className="cursor-pointer" />
      </div>
    </div>

    {/* tabs */}
    <div role="tablist" className="tabs tabs-bordered gap-4 px-2 border-b-2">
      <a role="tab" className={
        classNames('text-lg font-semibold tab py-3 px-1 mb-[-2px] h-auto border-b-2 border-transparent', {
          'tab-active border-[#263dff]': currentUseTab === 'graphql'
        })
      }
        onClick={() => {
          setCurrentUseTab('graphql')
        }}
      >
        GraphQL
      </a>
      <a role="tab" className={
        classNames('text-lg font-semibold tab py-3 px-1 mb-[-2px] h-auto border-b-2 border-transparent', {
          'tab-active border-[#263dff]': currentUseTab === 'sql'
        })}
        onClick={() => {
          setCurrentUseTab('sql')
        }}
      >
        SQL API
      </a>
    </div>
    {/* contents */}
    <div className="max-h-[calc(100vh-96px)] overflow-auto">
      {
        renderContents()
      }
    </div>

  </div>
}

const Build = ({
  newBuild
}: any) => {
  const [showUse, setShowUse] = useState(false)


  return <div className='min-w-[1240px] w-full relative'>
    {/* Top toolbar */}
    <div className="flex justify-between items-center border-b-2">
      <div className="p-3 border-r">
        <BiArrowBack />
      </div>
      <div>
        default project
      </div>
      <div>
        <UseButton onClick={() => { setShowUse(true) }} />
      </div>
    </div>
    <QueryBuilderV2 />
    {
      showUse && <UseSection onClose={() => setShowUse(false)} />
    }
  </div >
}

export default Build